var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 27C45 31.7739 43.1036 36.3522 39.7279 39.7279C36.3523 43.1036 31.7739 45 27 45C22.2261 45 17.6477 43.1036 14.2721 39.7279C10.8964 36.3522 9 31.7739 9 27C9 22.2261 10.8964 17.6477 14.2721 14.2721C17.6477 10.8964 22.2261 8.99998 27 8.99998C28.71 8.99998 30.375 9.24748 31.95 9.69748L35.4825 6.16498C32.7922 5.057 29.9095 4.49118 27 4.49998C24.0453 4.49998 21.1194 5.08196 18.3896 6.21269C15.6598 7.34342 13.1794 9.00076 11.0901 11.0901C6.87053 15.3096 4.5 21.0326 4.5 27C4.5 32.9674 6.87053 38.6903 11.0901 42.9099C13.1794 44.9992 15.6598 46.6565 18.3896 47.7873C21.1194 48.918 24.0453 49.5 27 49.5C32.9674 49.5 38.6903 47.1295 42.9099 42.9099C47.1295 38.6903 49.5 32.9674 49.5 27H45ZM17.7975 22.68L14.625 25.875L24.75 36L47.25 13.5L44.0775 10.305L24.75 29.6325L17.7975 22.68Z",
    fill: "#6EA84D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.3dfa7cf68b5eff6fe3d26ffac4fd16ca.svg";
export { ForwardRef as ReactComponent };